import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import * as React from 'react';
import shallowEqual from '../utils/shallowEqual';

var Field =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Field, _React$Component);

  var _super = _createSuper2(Field);

  function Field(props) {
    var _this;

    _classCallCheck(this, Field);

    _this = _super.call(this, props);
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this)); // this.cacheChildren = undefined
    // this.cacheElement = null

    return _this;
  }

  _createClass(Field, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var options = this.props.cache ? {
        skip: ['children']
      } : {};
      return !shallowEqual(this.props, nextProps, options);
    }
  }, {
    key: "handleChange",
    value: function handleChange(value) {
      if (value && value.nativeEvent) {
        // eslint-disable-next-line
        value = value.target.value;
      }

      this.props.onChange(value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          value = _this$props.value,
          error = _this$props.error,
          disabled = _this$props.disabled;

      if (typeof children === 'function') {
        return children({
          value: value,
          error: error,
          onChange: this.handleChange,
          disabled: disabled
        });
      }

      if (
      /*#__PURE__*/
      React.isValidElement(children)) {
        return (
          /*#__PURE__*/
          React.cloneElement(children, {
            value: value,
            error: error,
            onChange: this.handleChange,
            disabled: disabled || children.props && children.props.disabled
          })
        );
      }

      console.error(new Error('Form.Field expect a single ReactElement or a function.'));
      return null;
    }
  }]);

  return Field;
}(React.Component);

Field.defaultProps = {
  cache: false
};
export default Field;